<template>
  <div id="data-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Title" v-model="data_local.title" type="title" v-validate="'required'" name="title" />
        <span class="text-danger text-sm"  v-show="errors.has('title')">{{ errors.first('title') }}</span>

        <vs-textarea height="200px"  class="w-full mt-4" label="Message" v-model="data_local.message" v-validate="'required'" name="message" />
        <span class="text-danger text-sm"  v-show="errors.has('message')">{{ errors.first('message') }}</span>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <!-- Col Header -->
        <div class="flex items-end md:mt-4 mt-base">
          <feather-icon icon="FolderIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Files</span>
        </div>

        <!-- Col Content -->
        <div class="vx-row">

          <div class="vx-col w-full">
            <!-- uploading docs -->
            <div class="flex items-start flex-col sm:flex-row">
              <div v-if="files.length > 0" v-for="(item, file) in files">
                <feather-icon icon="XCircleIcon" svgClasses="h-6 w-6" style="top: 12px;left: 82px;color: #ea5455;" class="cursor-pointer" @click="deleteImage(fileKey[file], file)"/>
                <img :src="item" class="mt-4 mr-8 rounded h-24 w-24" />  
              </div>
              <p v-if="files.length ==0" class="mt-2">No files uploaded</p>
            </div>

            <div class="flex items-start flex-col sm:flex-row">
              
              <!-- <vs-avatar :src="data_localavatar" size="80px" class="mr-4" /> -->
              <!-- uploading docs -->
              <div class="mt-4">            
                <input type="file" multiple="multiple" id="fileD" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*">

                <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Upload Files</vs-button>
              </div>

            </div>
            
          </div>
        </div>        

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../../../axios'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      files: [],
      rawFiles: [],
      resDataLocal: [],
      resUp: [],
      fileKey: [],
      filesDel: [],

      token: localStorage.usertoken,
      data_local: JSON.parse(JSON.stringify(this.data)),

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    async loadData () {
      const editId = this.$route.params.editId
      try {    
          this.files = []
          //reading docs
          this.tableRead = await axios.post(`/docs/table/read/`, {
            token: this.token,
            path: `docs/unit-resident/gallery/${editId}`,
            document_folder_id: 24
          })

          //reading docs
          for (const [key, value] of Object.entries(this.tableRead.data.uploadedD)) {
            var imgB64 = this._arrayBufferToBase64( value.data.Body.data )
            var imgAsc = imgB64.toString('ascii')
            this.files.push("data:image/png;base64, " + imgAsc)
            this.fileKey.push(value.key)
          }

      } catch(err) {
        console.log(err.toString('utf8'));
      }
    },
    deleteImage(f, k) {
      // document.getElementById(f).style.display = 'none';
      console.log('f ', f)
      console.log('k ', k)
      this.$delete(this.fileKey, k)
      this.$delete(this.files, k)
      this.$delete(this.rawFiles, k)
      this.filesDel.push(f)

      this.$vs.notify({
        color: 'success',
        title: 'Deleting Data',
        text: 'File deleted'
      })
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */

      const editId = this.$route.params.editId
      new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/unit-resident/save/${editId}`, {
              data: this.data_local,
              token: this.token
            })
            .then(res => {
              if(res['data'] != 'access_denied' && res['data'] != '') {

                if(res['data'] == 'success') {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Data Saved',
                    text: 'The selected data was successfully Saved'
                  })
                  // this.$router.push({name:'app-unit-resident-view', params: {viewId: editId }})
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Saving Data',
                    text: 'Something went wrong'
                  })
                }

              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                this.$router.push({name:'app-unit-resident-view', params: {viewId: editId }})
              }

            })
            .catch(err => {
              this.$vs.notify({
                color: 'danger',
                title: 'Data Saving Error',
                text: 'The selected data was not saved'
              })
            }) 

          // uploading docs
          await axios.post(`/docs/table/save`, {
            rawFiles: this.rawFiles,
            token: this.token,
            id: editId,
            path: `docs/unit-resident/gallery/${editId}`,
            folderId: 24
          })

          // delete docs
          await axios.post(`/docs/table/delete`, {
            data: this.filesDel,
            token: this.token
          })

          this.$router.push({name:'app-unit-resident-view', params: {viewId: editId }})
        } catch(err) {
          reject(err.toString('utf8'));
        }      

      }) 
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
    //uploading docs
    _arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },
    //uploading docs
    async update_avatar () {
      this.$vs.loading()
      var formdata = new FormData();
      $.each($('#fileD')[0].files, function(i, file) {
        formdata.append('fileD_'+i, file);
      });
      formdata.append('token', this.token)

      this.resUp = await axios.post(`/docs/upload`,  
        formdata, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        }
      )

      for (const [key, value] of Object.entries(this.resUp.data.rawD)) {
        var imgB64 = this._arrayBufferToBase64( value.data.data )
        var imgAsc = imgB64.toString('ascii')
        this.files.push("data:image/png;base64, " + imgAsc)
      }

      if (this.resUp.data.uploadedD.length > 1) {
        for (const [key, value] of Object.entries(this.resUp.data.uploadedD)) {
          this.rawFiles.push(value)
        }
      } else {
        this.rawFiles[0] = this.resUp.data.uploadedD
      }

      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
    },
  },
  created () {
    this.loadData()
  } 
}
</script>
